import React from 'react'

export const WideEllipse = ({ blue }) => (
  blue
    ? <svg width="100%" height="1023" viewBox="0 0 1440 1023" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path d="M736 0.5C1059.54 0.5 1352.44 95.78 1564.44 249.803C1776.43 403.826 1907.5 616.564 1907.5 851.5C1907.5 1086.44 1776.43 1299.17 1564.44 1453.2C1352.44 1607.22 1059.54 1702.5 736 1702.5C412.455 1702.5 119.56 1607.22 -92.4355 1453.2C-304.432 1299.17 -435.5 1086.44 -435.5 851.5C-435.5 616.564 -304.432 403.826 -92.4355 249.803C119.56 95.78 412.455 0.5 736 0.5Z" fill="url(#paint0_radial_268_1623)" stroke="#0000FF"/>
        <defs>
          <radialGradient id="paint0_radial_268_1623" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(736 851.5) rotate(90) scale(875.013 1204.36)">
            <stop offset="0.822011"/>
            <stop offset="1" stop-color="#0000FF"/>
          </radialGradient>
        </defs>
      </svg>
    : <svg width="100%" height="1023" viewBox="0 0 1440 1023" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path d="M736 0.5C1059.54 0.5 1352.44 95.78 1564.44 249.803C1776.43 403.826 1907.5 616.564 1907.5 851.5C1907.5 1086.44 1776.43 1299.17 1564.44 1453.2C1352.44 1607.22 1059.54 1702.5 736 1702.5C412.455 1702.5 119.56 1607.22 -92.4355 1453.2C-304.432 1299.17 -435.5 1086.44 -435.5 851.5C-435.5 616.564 -304.432 403.826 -92.4355 249.803C119.56 95.78 412.455 0.5 736 0.5Z" fill="url(#paint0_radial_103_1844)" stroke="#FD002D"/>
        <defs>
          <radialGradient id="paint0_radial_103_1844" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(736 851.5) rotate(90) scale(875.013 1204.36)">
            <stop offset="0.822011"/>
            <stop offset="1" stopColor="#FD002D"/>
          </radialGradient>
        </defs>
      </svg>
)